import {Component, inject, Input} from '@angular/core';
import {PlayingVenue} from '../../../../../../model/masterdata/PlayingVenue';
import {LocationPipe} from '../../../../../shared/pipes/location.pipe';
import {Button} from 'primeng/button';
import {TooltipModule} from 'primeng/tooltip';
import {TranslateModule} from '@ngx-translate/core';
import {DividerModule} from 'primeng/divider';
import {
  InformationPresenterComponent
} from '../../../../../shared/playingVenue/information/information-presenter/information-presenter.component';
import {WindowService} from '../../../../../../services/window.service';

@Component({
  standalone: true,
  selector: 'app-frontend-playingvenue-data',
  templateUrl: './frontend-playingvenue-data.component.html',
  imports: [
    Button,
    TooltipModule,
    TranslateModule,
    DividerModule,
    InformationPresenterComponent
  ],
  styleUrls: ['./frontend-playingvenue-data.component.scss']
})
export class FrontendPlayingvenueDataComponent
{
  private windowService = inject(WindowService);
  private locationPipe = inject(LocationPipe);

  location: string;
  playingVenueIntern: PlayingVenue;
  @Input() set playingVenue(value: PlayingVenue)
  {
    this.playingVenueIntern = value;
    if (this.playingVenueIntern)
     this.location = this.locationPipe.transform(this.playingVenueIntern);
  }
  @Input() showName = true;

  public openGoogleMaps(): void
  {
    if (this.location)
      this.windowService.openGoogleMaps(this.location);
  }
}
